/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar25 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar25", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M13.77,21.543H8.414 v-1.196l2.227-2.095c1.035-0.957,1.299-1.313,1.299-1.729c0-0.518-0.381-0.864-0.963-0.864c-0.605,0-1.025,0.41-1.025,0.991v0.034 H8.311v-0.029c0-1.401,1.094-2.349,2.73-2.349c1.576,0,2.631,0.845,2.631,2.09c0,0.781-0.459,1.475-1.709,2.588l-1.162,1.069v0.093 h2.969V21.543z M18.896,21.734c-1.637,0-2.73-0.962-2.754-2.241h1.625c0.084,0.518,0.553,0.859,1.143,0.859 c0.654,0,1.119-0.449,1.119-1.138c0-0.703-0.469-1.172-1.123-1.172c-0.498,0-0.85,0.225-1.074,0.581h-1.578l0.332-4.126h4.688v1.396 h-3.305l-0.133,1.636h0.094c0.273-0.439,0.771-0.723,1.494-0.723c1.338,0,2.295,0.991,2.295,2.363 C21.719,20.694,20.596,21.734,18.896,21.734z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar25.defaultProps = {
  className: null
};

IconCalendar25.propTypes = {
  className: PropTypes.string
};

export default IconCalendar25;
